let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f6D72")).then(() => parcelRequire('caK1o'));